import createClient from '../../apolloClient';
import MUTATION_SIGN_IN from '../../mutation/signIn';

const handleSignIn = async (variables) => {
  const client = createClient();
  const result = await client.mutate({
    mutation: MUTATION_SIGN_IN,
    variables,
  });
  const { signIn } = result?.data || {};
  if (!signIn?.isSuccess) throw signIn.message;
  return { me: signIn.me, accessToken: signIn.accessToken };
};
export default handleSignIn;
